// x-responsive-table.js

/*
Two different approches for handling table widths on small screens.
- Automatic, done by default: Checks all tables (except custom) for overflow and adds class if they do.
- Manual: responsive-table class added by author to break down table vertically on small screens.
*/

export default function xResponsiveTable() {

  /*******************************************************************************
  * Automatic check if tables overflow.
  * Use exclusion-class on table to escape this behavior.
  * Dedicated check for when opening details element.
  * If overflow, set class and style property used in CSS to control width.
  ********************************************************************************/

  function checkTableOverflow() {
    const allTables = document.querySelectorAll("table:not(.custom-responsive)");
    const viewportWidth = window.innerWidth;

    allTables.forEach(table => {
      const tableWidth = table.offsetWidth;
      const tableLeftPos = table.getBoundingClientRect().left;

      // Elements that limit width. Add selectors as needed.
      const widthLimiter = table.closest(".vrtx-details");

      let availableWidth;

      // If table is inside widthLimiter, limit width to that
      if (widthLimiter) {
        availableWidth = widthLimiter.offsetWidth;
      }
      // Else assuming (for now) that table has full viewport width available
      else {
        availableWidth = viewportWidth - tableLeftPos - 15; // Subtract a bit from browser edge
      }

      // If overflows available width, add class and variable for CSS
      if (tableWidth > availableWidth) {
        table.classList.add("overflows");
        table.style.setProperty("--availableWidth", availableWidth + "px");
      }
    });
  }

  checkTableOverflow();

  // Run check when opening details elements
  const allDetails = document.querySelectorAll(".vrtx-details");
  allDetails.forEach(details => {
    details.addEventListener("toggle", () => {
      if (details.open) {
        checkTableOverflow();
      }
    });
  });



  /**************************************************************************************************
  * Manual: responsive-table class added by author to break down table vertically on small screens
  ***************************************************************************************************/

  const responsiveTables = document.querySelectorAll(".responsive-table");
  let tableHeadings = "";
  let tableRows = "";
  let tableCells = "";
  for (let t = 0; t < responsiveTables.length; t++) {
    tableHeadings = responsiveTables[t].querySelectorAll("thead th");
    tableRows = responsiveTables[t].querySelectorAll("tbody tr");
    for (let i = 0; i < tableRows.length; i++) {
      tableCells = tableRows[i].querySelectorAll("td");
      if (tableRows[i].querySelectorAll("th").length > 0) {
        for (let j = 1; j < tableHeadings.length; j++) {
          tableCells[j-1].innerHTML = '<span class="responsive-content"><strong>' + tableHeadings[j].innerHTML + ':</strong></span> ' + tableCells[j-1].innerHTML ;
        }
      }
      else {
        for (let j = 1; j < tableHeadings.length; j++) {
          tableCells[j].innerHTML = '<span class="responsive-content"><strong>' + tableHeadings[j].innerHTML + ':</strong></span> ' + tableCells[j].innerHTML ;
        }
      }
    }
  }
}